(function () {
  var STORAGE_KEY = 'wwd_wishlist_v1';
  var drawer = null;
  var triggers = [];

  function readWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function normalizeItem(item) {
    return {
      id: String(item.id || ''),
      handle: item.handle || '',
      title: item.title || '',
      url: item.url || '',
      image: item.image || '',
      price: item.price || '',
      vendor: item.vendor || '',
      addedAt: item.addedAt || new Date().toISOString()
    };
  }

  function findIndex(items, id) {
    return items.findIndex(function (item) { return String(item.id) === String(id); });
  }

  function isSaved(id) {
    return findIndex(readWishlist(), id) > -1;
  }

  function addItem(item) {
    var items = readWishlist();
    if (findIndex(items, item.id) === -1) {
      items.unshift(normalizeItem(item));
      saveWishlist(items);
    }
    updateWishlistUI();
  }

  function removeItem(id) {
    var items = readWishlist().filter(function (item) {
      return String(item.id) !== String(id);
    });
    saveWishlist(items);
    updateWishlistUI();
  }

  function toggleItem(item) {
    if (isSaved(item.id)) {
      removeItem(item.id);
      return false;
    }
    addItem(item);
    return true;
  }

  function getButtonItem(button) {
    return normalizeItem({
      id: button.getAttribute('data-product-id'),
      handle: button.getAttribute('data-product-handle'),
      title: button.getAttribute('data-product-title'),
      url: button.getAttribute('data-product-url'),
      image: button.getAttribute('data-product-image'),
      price: button.getAttribute('data-product-price'),
      vendor: button.getAttribute('data-product-vendor')
    });
  }

  function syncProductButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-button]');
    buttons.forEach(function (button) {
      var saved = isSaved(button.getAttribute('data-product-id'));
      var icon = button.querySelector('.fa');
      button.classList.toggle('is-active', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('title', saved ? 'Vom Merkzettel entfernen' : 'Auf den Merkzettel setzen');
      if (icon) {
        icon.classList.remove('fa-heart', 'fa-heart-o');
        icon.classList.add(saved ? 'fa-heart' : 'fa-heart-o');
      }
    });
  }

  function updateCounters() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = count > 99 ? '99+' : String(count);
      node.classList.toggle('hide', count === 0);
    });
    document.querySelectorAll('[data-wishlist-open]').forEach(function (node) {
      var icon = node.querySelector('.fa');
      node.classList.toggle('is-active', count > 0);
      node.setAttribute('aria-label', 'Merkzettel' + (count ? ' (' + count + ')' : ''));
      if (icon) {
        icon.classList.remove('fa-heart', 'fa-heart-o');
        icon.classList.add(count > 0 ? 'fa-heart' : 'fa-heart-o');
      }
    });
  }

  function renderDrawer() {
    if (!drawer) drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;

    var body = drawer.querySelector('[data-wishlist-body]');
    if (!body) return;

    var items = readWishlist();
    if (!items.length) {
      body.innerHTML = '<div class="wwd-wishlist-empty"><p>Sie haben noch keine Produkte auf Ihrem Merkzettel gespeichert.</p><a href="/collections/all">Jetzt Produkte entdecken</a></div>';
      return;
    }

    var html = '<div class="wwd-wishlist-list">';
    items.forEach(function (item) {
      var image = item.image ? '<a class="wwd-wishlist-item__image" href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '"></a>' : '<a class="wwd-wishlist-item__image" href="' + escapeHtml(item.url) + '"></a>';
      html += '<div class="wwd-wishlist-item">';
      html += image;
      html += '<div class="wwd-wishlist-item__content">';
      html += '<h3 class="wwd-wishlist-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>';
      if (item.vendor) {
        html += '<p class="wwd-wishlist-item__meta">' + escapeHtml(item.vendor) + '</p>';
      }
      if (item.price) {
        html += '<p class="wwd-wishlist-item__price">' + escapeHtml(item.price) + '</p>';
      }
      html += '<div class="wwd-wishlist-item__actions">';
      html += '<a class="wwd-wishlist-item__link" href="' + escapeHtml(item.url) + '">Zum Produkt</a>';
      html += '<button type="button" class="wwd-wishlist-item__remove" data-wishlist-remove="' + escapeHtml(item.id) + '">Entfernen</button>';
      html += '</div></div></div>';
    });
    html += '</div>';
    body.innerHTML = html;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function openDrawer() {
    if (!drawer) drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wwd-wishlist-open');
  }

  function closeDrawer() {
    if (!drawer) drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wwd-wishlist-open');
  }

  function updateWishlistUI() {
    syncProductButtons();
    updateCounters();
    renderDrawer();
  }

  function bindWishlistButtons(scope) {
    (scope || document).querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      if (button.__wishlistBound) return;
      button.__wishlistBound = true;
      button.addEventListener('click', function () {
        var added = toggleItem(getButtonItem(button));
        if (added) {
          openDrawer();
        }
      });
    });
  }

  function bindOpeners(scope) {
    (scope || document).querySelectorAll('[data-wishlist-open]').forEach(function (button) {
      if (button.__wishlistOpenBound) return;
      button.__wishlistOpenBound = true;
      button.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });
  }

  function bindDrawer() {
    if (!drawer) drawer = document.querySelector('[data-wishlist-drawer]');
    if (!drawer || drawer.__wishlistBound) return;
    drawer.__wishlistBound = true;

    drawer.addEventListener('click', function (event) {
      if (event.target.matches('[data-wishlist-close]') || event.target.matches('[data-wishlist-backdrop]')) {
        closeDrawer();
      }

      var removeButton = event.target.closest('[data-wishlist-remove]');
      if (removeButton) {
        removeItem(removeButton.getAttribute('data-wishlist-remove'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.querySelector('[data-wishlist-drawer]');
    bindWishlistButtons(document);
    bindOpeners(document);
    bindDrawer();
    updateWishlistUI();
  });
})();
